import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import {
  assigment_upload_api,
  class_api,
  section_api,
  subject_api,
} from "../api/Users";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";

const AddAssignment = ({ userData }) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const rowData = location.state;

  const [assignment, setAssignment] = useState({
    class_id:"",
    section_id:"",
    subject_id:""
  });
  const [error, setErrors] = useState({});

  const [photo, setPhoto] = useState(null);

  const [isClass, setClass] = useState([]);
  const [isSection, setSection] = useState([]);
  const [isSubject, setSubject] = useState([]);
  const[schoolid, setSchoolId] =useState([]);
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No assignment document selected!.");
      return;
    }

    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;

    if (!allowedExtensions.test(file.name)) {
      toast.error(
        "Invalid file type. Only JPG, PNG and PDF files are allowed."
      );
      event.target.value = "";
      return;
    }
    setPhoto(file);
  };

  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      setAssignment((assignment) => ({ ...assignment, [name]: value }));
    } else {
      const file = files[0];
      setAssignment((assignment) => ({ ...assignment, [name]: file }));
    }
  };
  const handleSection = (e) => {
    const { name, value } = e.target;
    setIsLoading(true);
    let data = {
      class_id: value,
    };
    setAssignment((assignment) => ({ ...assignment, [name]: value })); // Update assignment state
    section_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.section_data) {
          setIsLoading(false);
          setSection(res.data.section_data);
        } else {
          toast.error(t("Section data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });
  
    subject_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.subject_data) {
          setSubject(res.data.subject_data);
        } else {
          toast.error(t("Subject data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });
  };
  
  const handleSchoolId =() =>{
    setSchoolId(userData.data.school_id);
  }

  const handleClass = () => {
    if (!userData || !userData.data || !userData.data.school_id) {
      toast.error(t("User data is not available"));
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    let data = {
      school_id: userData.data.school_id,
    };
    class_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.class_data) {
          setClass(res.data.class_data);
        } else {
          toast.error(t("Class data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (rowData) {
      setAssignment((prevStaff) => ({
        ...prevStaff,
        ...rowData,
      }));
    }
    handleClass();
    handleSchoolId();
  }, [rowData]);

  const navigate = useNavigate();

  const onSubmit = (e,userData) => {
    e.preventDefault();
    const formErrors = {};

    if (photo == null) {
      formErrors.photo_file = "No assignment photo selected!";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      const formData = new FormData();

      // Append each field and its value to the FormData object
      formData.append("school_id", schoolid);
      
      formData.append("class_id", assignment.class_id);
      formData.append("section_id", assignment.section_id);
      formData.append("subject_id", assignment.subject_id);
      formData.append("title", assignment.title);
      formData.append("description", assignment.description);
      formData.append("date_of_assignment", assignment.date_of_assignment);
      formData.append("last_submission_date", assignment.last_submission_date);

      assigment_upload_api(formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            window.location.reload();
          } else {
            toast.error(t(res.message));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const reset = () => {
    navigate(`/assignments`);
  };
  return (
    <>
      <div className="px-2 px-md-4">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add Assignment")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {t("Upload Document")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="file"
                name="file"
                accept=".pdf"
                className="form-control"
                onChange={handlePhotoChange}
              />
              {error.assignment_photo && (
                <div className="text-danger">{error.assignment_photo}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Class")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="class_id"
                onChange={handleSection}
                className="form-control"
                placeholder="Select Class"
                required
              >
                <option value="">Select Class</option>
                {isClass.map((classItem) => (
                  <option key={classItem.class_id} value={classItem.class_id}>
                    {classItem.class}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Section")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="section_id"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select Section</option>
                {isSection.map((classItem) => (
                  <option
                    key={classItem.section_id}
                    value={classItem.section_id}
                  >
                    {classItem.section}
                  </option>
                ))}
              </select>
              {error.section && (
                <div className="text-danger">{error.section}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Subject")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="subject_id"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select Subject</option>
                {isSubject.map((classItem) => (
                  <option
                    key={classItem.subject_id}
                    value={classItem.subject_id}
                  >
                    {classItem.subject}
                  </option>
                ))}
              </select>
              {error.subject && (
                <div className="text-danger">{error.subject}</div>
              )}
            </div>

            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Date of Assignment")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                name="date_of_assignment"
                className="form-control"
                onChange={handleChangeInput}
                // required
              />
              {error.date_of_assignment && (
                <div className="text-danger">{error.date_of_assignment}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Last date of submission")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                name="last_submission_date"
                className="form-control"
                onChange={handleChangeInput}
                // required
              />
              {error.last_submission_date && (
                <div className="text-danger">{error.last_submission_date}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Title")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                name="title"
                className="form-control"
                // required
              />
              {error.title && <div className="text-danger">{error.title}</div>}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Description")} {<span style={{ color: "red" }}>*</span>}
              </label>

              <textarea
                onChange={handleChangeInput}
                className="form-control"
                name="description"
                style={{ backgroundColor: "#e9ecef", color: "#495057" }}
              />
              {error.description && (
                <div className="text-danger">{error.description}</div>
              )}
            </div>
            <div
              className="col-md-4 d-flex align-items-start"
              style={{ marginTop: "3.5rem" }}
            >
              <button type="submit" className="btn btn-primary me-4 col-md-5 ">
                {t("Save")}
              </button>

              <button
                type="submit"
                className="btn btn-secondary me-4 col-md-5"
                onClick={reset}
              >
                {t("Cancel")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddAssignment;
